import React from 'react'
import { useTranslation } from 'react-i18next'

const HikingPoints = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>{t('POINTS_TITLE')}</h2>
      <ul className="ul-square">
        <li>
          {t('HIKING_POINTS_PHYSICALLY_DEMANDING')}
          {/* (en savoir +) */}
        </li>
        <li>
          {t('POINTS_RESPECT_ECOSYSTEM')}
          {/* (en savoir +) */}
        </li>
        <li>
          {t('POINTS_RESPECT_PEOPLE')}
          {/* (en savoir +) */}
        </li>
      </ul>
    </div>
  )
}

export default HikingPoints
